import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import { Close, Home } from '@material-ui/icons';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';

import { wsRemove, wsUpdate } from 'services/WService.js';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import StockData from './Stocks/StockData';

export default function ValueBoniGroup(props) {
  const statePromo = props.promo.state == 'N' || props.promo.state == 'G' ? false : true;
  const [dataBoniGroup, setDataBoniGroup] = useState(props.boniGroup);
  const [quantity, setQuantity] = useState(props.boniGroup?.quantity);

  const [open, setOpen] = useState(false);

  async function deleteBoniGroup() {
    let response = await wsRemove('prom/bonification-group', props.boniGroup.id);
    if (response.success) {
      props.showNotify(response.message);
      props.reload();
    }
  }

  async function updateBoniGroup(data) {
    let response = await wsUpdate('prom/bonification-group', props.boniGroup.id, data);
    if (response.success) {
      props.showNotify(response.message);
    } else {
      props.showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    setDataBoniGroup(props.boniGroup);
    setQuantity(props.boniGroup.quantity);
  }, [props.boniGroup, props.rule?.id]);

  return (
    <GridContainer>
      {dataBoniGroup.condition === 'Q' && open && props.boniGroup?.products?.length > 0 ? (
        <ModalFull
          title={'Stock por almacénes del grupo ' + props.grupo}
          open={open}
          setOpen={setOpen}
        >
          <StockData idGroup={props.boniGroup.id} entity="prom/bonification-group" tipo="B" />
        </ModalFull>
      ) : undefined}

      <GridItem xs={3}>
        <TextField
          label="Cantidad grupo"
          type="number"
          name="quantity"
          value={quantity || ''}
          onChange={(e) => {
            setQuantity(e.target.value);
            if (e.target.value < 1 || e.target.value === '') {
              props.showNotify('El mínimo aceptado es 1', 'info');
              setQuantity(1);
              updateBoniGroup({ quantity: 1 });
            } else {
              updateBoniGroup({ quantity: e.target.value });
            }
          }}
          inputProps={{ min: 0 }}
          disabled={statePromo}
        />
      </GridItem>
      <GridItem xs={3}>
        <Button
          justIcon
          color="danger"
          disabled={statePromo}
          onClick={() => props.confirmDeleteGroup(deleteBoniGroup)}
        >
          <Close />
        </Button>

        {dataBoniGroup.condition === 'Q' && props.boniGroup?.products.length > 0 ? (
          <Button
            justIcon
            color="primary"
            style={{ marginLeft: '15px' }}
            onClick={() => setOpen(true)}
          >
            <Home />
          </Button>
        ) : undefined}
      </GridItem>
    </GridContainer>
  );
}
